<template>
    <div class="DM_terminalAdjust">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item>
				    <el-input size clearable v-model="searchForm.phone" placeholder="请输入代理账号"></el-input>
				</el-form-item>
				<el-form-item>
				    <el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理编号"></el-input>
				</el-form-item>
<!--                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="提出开始时间"
                            end-placeholder="提出结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="DateChange"
                    ></el-date-picker>
                </el-form-item> -->
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addHideRule">添加</el-button>
            </div>
            <el-table
                    :data="feedbackList"
                    size="mini"
                    border 
                    style="width: 100%"
                    v-loading="loading"
                    max-height="500px"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="100"
                ></el-table-column>
                <!-- 主机构 -->
<!--                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_name"
                        label="主机构"
                        min-width="210"
                ></el-table-column> -->
                <!-- 代理商 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="nickname"
                        label="代理商"
                        min-width="120"
                ></el-table-column>
                <!-- 手机号 --> 
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="phone"
                        label="代理商手机号"
                        min-width="120">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                            <p>{{ scope.row.phone | desMobile }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="政策"
                        min-width="120"
                ></el-table-column>
                <!-- 平台预留 -->
               <el-table-column
                        header-align="center"
                        align="center"
                        prop="platform_percent"
                        label="平台预留（%）"
                        min-width="120"
                ></el-table-column>
				<!-- 平台预留 -->
				<el-table-column
				         header-align="center"
				         align="center"
				         prop="under_percent"
				         label="直属代理商预留（%）"
				         min-width="150"
				 ></el-table-column>
                <!-- 提升费率 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="rate_limit"
                        label="费率上限（/万）"
                        min-width="120"
                ></el-table-column>
                <!-- 提升秒到费 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="sec_fee_limit"
                        label="秒到费上限（元）"
                        min-width="120"
                ></el-table-column>
				<!-- 备注 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="type_name"
				        label="提升类型"
				        min-width="120"
				></el-table-column>
                <!-- 备注 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="notes"
                        label="备注"
                        min-width="180"
                ></el-table-column>
				<!-- 添加时间 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="status"
				        label="状态"
				        min-width="80"
				></el-table-column>
                <!-- 添加时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="create_time"
                        label="添加时间"
                        min-width="150"
                ></el-table-column>

               <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="180">
                    <template slot-scope="scope" >
						<el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button
                            @click="submit(scope.row.id)"
                            type="text"
                            size="small"
                        >查看终端</el-button>
                        <el-button
                                @click="subData(scope.row.id)"
                                type="text"
                                size="small"
                        >查看交易数据</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10,20,50,100]"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <terminal-add
                v-if="terminalAdjustAdd"
                :terminalAdjustAdd="terminalAdjustAdd"
				:freeId="freeId"
				:freeEdit="freeEdit"
                @infoClose="infoClose"
        ></terminal-add>
    </div>
</template>

<script>
import terminalAdd from "./MAM_TerminalAdjustAdd";
export default {
    name: "DM_transactionHide",
    data() {
        return {
            terminalAdjustAdd: false, //弹窗
            feedbackList: [], //table
            rangeDate: [],
			freeId:null,
			freeEdit:false,
            searchForm: {
				phone:'',
				agent_no:'',
                page: 1,
                limit: 10,
                start_time: '', //提出开始时间
                end_time: '' //提出结束时间
            },
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            admin_id: sessionStorage.getItem('admin_id')
        }
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    components: {
        terminalAdd
    },
    methods: {
        addHideRule() { //添加分类
            this.terminalAdjustAdd = true;
			this.freeEdit = false;
        },
		handleEdit(row) { //编辑
		    this.freeId = row.id;
            this.terminalAdjustAdd = true;
            this.freeEdit = true;
		},
        infoClose() { //关闭弹窗
            this.terminalAdjustAdd = false;
            this.getData(this.searchForm);
        },
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("terminal/terminal_adjust_list", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.feedbackList = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        DateChange(DateArr) {
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
        submit(val) {
            this.$router.push({ path: '/terminalAdjustInfo', query: {id:val}});
        },
        subData(val) {
            this.$router.push({ path: '/terminalAdjustDetail', query: {id:val}});
        }
    }
};
</script>

<style lang="scss" scoped>
.APP_feedbackList {
}
</style>
